var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[(!this.$props.addClt)?_c('div',{class:_vm.listStyle},[_c('List',_vm._g({attrs:{"__list":_vm.dataArray,"__isOnLoad":_vm.isListOnload,"__userList":this.userList}},{allowUpdateRq: _vm.onAllowUpdateRq}))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }